import type { FaireProductEntity } from "../../entity_types/product";

export const p_w8w332gpps: FaireProductEntity = {
  token: "p_w8w332gpps",
  type: "product",
  name: "The Words You Speak Hanging Decor",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/46d6f9be41c2a640dfaeb0c89b4d9778c56e67ed4991ab9be64b8756af252b66.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c772f8320b8004eac1680fd57c22c340980eee5b1a5e11f087cc7b3a224e89fe.jpeg",
    "https://cdn.faire.com/fastly/2cf36bcfee4cb1ade7784ca9f6dea403a0962ad4dc4ad7b4c31c5aae3067ad04.jpeg",
    "https://cdn.faire.com/fastly/c71af2eb7f0eb0de915f707a1e07208a80c90a912a68ef7c18d6c2e910e5f6d2.jpeg"
  ],
  priceDollars: 5,
  description: "A ready to hang metal tin sign from our Slow Living Collection displaying an inspirational sentiment that reads \"The Words You Speak Become The House You Live In\" perfect for those who enjoy cozy home life. Cozy living sign features metal with embossed details for added dimension. Our The Words You Speak metal wall décor is easy to hang against wall using the included mounting hardware and pre-drilled holes. A cozy living home accent that easily adds personality to any space.",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:42.100Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
